<template>
  <div class="search-container clearfix" ref="search_contaienr" :style="containerStyle">
    <div class="search-main">
      <div class="search-bar">
        <input type="text" v-model="inputValue" @keydown.enter="goSearch" class=search-input :placeholder="placeholder">
        <!--箭头-->
        <span v-show="showIcon" class='icon-down' @click="showMore">
          <i class="el-icon-caret-bottom"></i>
        </span>
        <!--搜索按钮-->
        <i @click="goSearch" class="icon-search go-search"></i>
      </div>
      <transition name="genaral-fadeIn">
        <div class=toggle-show-inner v-show="showToggleTable">
          <slot></slot>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        disabled: false,
        showToggleTable: false,
        change: false,
        inputValue: ""
      }
    },
    watch: {
      showToggleTable(val) {
        if (val) {
          document.onclick = () => {
            this.showToggleTable = false;
            document.onclick = null;
          }
        }
      }
    },
    props: {
      showSeven: {
        type: Boolean,
        default: true,
      },
      placeholder: {
        type: String,
        default: "点击下拉可高级搜索",
      },
      showIcon: {
        type: Boolean,
        default: true,
      },
      containerStyle:{
        type:Object,
        default:()=>{
          return{
            width:'350px'
          }
        }
      }
    },
    methods: {
      showMore(e) {
        this.showToggleTable = !this.showToggleTable;
      },
      goSearch() {
        this.$emit("on-search", this.inputValue);
      },
      toggleOpen(close) {
        this.showToggleTable = close;
      }
    },
    mounted() {
      this.$refs.search_contaienr.onclick = (e) => {
        e.stopPropagation();
      };
    }
  }
</script>
<style>
  /*动画函数*/
  .genaral-fadeIn-enter-active {
    transition: all .5s;
  }

  .genaral-fadeIn-leave-active {
    transition: all .5s;
  }

  .genaral-fadeIn-enter, .genaral-fadeIn-leave-to {
    transform-origin: top;
    transform: rotateX(30deg);
    opacity: 0;
  }
</style>
<style scoped>
  .icon-calander, .icon-search, .icon-down {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
    overflow: hidden;
  }

  .icon-calander {
    left: 5px;
    top: 2px;
  }

  .icon-down img {
    position: absolute;
    top: -12px;
    left: 6px;
  }

  .icon-calander img {
    position: absolute;
    top: -40px;
  }

  .icon-search img {
    position: absolute;
    left: 0;
    top: -77px;
  }
/*
  .search-container {
    width: 415px;
  }*/

  .search-container .search-main {
    position: relative;
    /*width:340px;*/
    width: 100%;
    border-radius: 5px;
    float: right;
  }

  .search-container .toggle-show-inner {
    padding: 20px;
    box-sizing:border-box;
    position: absolute;
    top: 100%;
    left: 1px;
    /*width:332px;*/
    width: calc(100% - 2px);
    z-index: 100;
    border-top: 1px solid rgb(205, 212, 203);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    background-color: white;
    /*overflow: hidden;*/
    box-shadow: 0px 1px 4px 0px #999;
  }

  .search-container .search-main .search-bar {
    position: relative;
    overflow: hidden;
    z-index: 120;
    background-color: transparent;
  }

  .search-container .search-main .search-bar .icon-down {
    display: table;
    float: left;
    border-top: 1px solid rgb(205, 212, 203);
    border-bottom: 1px solid rgb(205, 212, 203);
    cursor: pointer;
    background-color: #fff;
    text-align: center;
    color: #969696;
  }

  .search-bar .icon-down i {
    display: table-cell;
    vertical-align: middle;
  }

  .search-container .search-main .search-bar * {
    box-sizing: border-box;

  }

  .search-container .search-main .search-input {
    float: left;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    height: 40px;
    line-height: 40px;
    /*width: 280px;*/
    width: calc(100% - 80px);
    border: 1px solid rgb(205, 212, 203);
    border-right: 0;
    text-indent: 15px;
    font-size: 12px;
  }

  .search-container .search-main .search-input:focus {
    outline: none;
  }

  .search-container .search-main .search-input:first-line {
    color: #999;
  }

  .search-container .search-main .go-search {
    float: left;
    display: inline-block;
    width: 40px;
    height: 40px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border: 1px solid rgb(205, 212, 203);
    cursor: pointer;
    background: url("../../assets/images/sprite.png") no-repeat 0 0;
    background-position: 11px -1246px;
  }

  /********************/
  .search-container .search-main .search-show {
    width: 100%;
  }

  .search-container .search-show tr td {
    padding: 4px 2px;
  }

  .search-container .search-show tr td:first-child {
    text-align: right;
    font-size: 14px;
  }

  .search-container .search-show input {
    width: 240px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AdvancedSearch/index.vue